import { Array, Number, Record, Static, String, Undefined } from 'runtypes';

import { IdoButtonRunType } from 'src/models/ido';
import { SpoingButtonRunType } from 'src/models/spoing';
import { StatusButtonRunType } from 'src/models/status';
import { TaskButtonRunType } from 'src/models/task';

export const ContactPersonAvailableUsersRunType = Record({
	displayName: String,
	id: Number,
	userAvatar: String,
});

export type ContactPersonAvailableUsers = Static<typeof ContactPersonAvailableUsersRunType>;

export const AvailableCommunicationTypesRunType = Record({
	communicationType: String,
	id: String,
});

export type AvailableCommunicationTypes = Static<typeof AvailableCommunicationTypesRunType>;

export const MemoRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	alarm: String,
	author: String,
	authorId: String,
	availableCommunicationTypes: Array(AvailableCommunicationTypesRunType),
	communicationTypeId: String,
	contactPersonAvailableUsers: Array(ContactPersonAvailableUsersRunType),
	contactPersonId: Number,
	content: String,
	duration: String,
	extras: Array(Undefined),
	idoButton: IdoButtonRunType,
	spoingButton: SpoingButtonRunType,
	statusButton: StatusButtonRunType,
	taskButton: TaskButtonRunType,
	timestamp: String,
	title: String,
});

export type Memo = Static<typeof MemoRunType>;

export const PersonalMemoRunType = Record({
	height: Number,
	text: String,
	width: Number,
});

export type PersonalMemo = Static<typeof PersonalMemoRunType>;
